"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NotFound = exports.Home = exports.Docs = void 0;
var Docs_1 = require("./Docs");
Object.defineProperty(exports, "Docs", { enumerable: true, get: function () { return Docs_1.Docs; } });
var Home_1 = require("./Home");
Object.defineProperty(exports, "Home", { enumerable: true, get: function () { return Home_1.Home; } });
var NotFound_1 = require("./NotFound");
Object.defineProperty(exports, "NotFound", { enumerable: true, get: function () { return NotFound_1.NotFound; } });
